module.exports = __webpack_public_path__ + "img/share-icon.0f55352f.png";